import React, { memo } from 'react';
import '../css/loader.css';
import Red from '../Components/Assets/red.svg';
import Background from '../Components/background/background';
import { useLocation } from "react-router-dom";
import BackgruseRedirectIfNotLoggedIn from '../Components/redirect/redirect';

const PatientContextMissing = memo(() => {
  const location = useLocation();
  const { openedViaButton = false } = location.state || {};
  
  BackgruseRedirectIfNotLoggedIn(openedViaButton);

  return (
    <div className="relative h-screen w-screen bg-gradient-to-br from-red-50 to-orange-50 overflow-hidden">
      {/* Animated Background */}
      <Background />

      {/* Centered Error Content */}
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="bg-white/90 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-red-100 text-center max-w-sm sm:max-w-lg w-full">
          <div className="relative mb-6">
            <div className="absolute inset-0 bg-red-100 rounded-full w-32 h-32 sm:w-40 sm:h-32 mx-auto animate-pulse opacity-50"></div>
            <img
              src={Red}
              alt="Patient context missing illustration"
              className="relative mx-auto w-32 h-24 sm:w-40 sm:h-32 object-contain"
              loading="lazy"
              width="160"
              height="128"
            />
          </div>
          
          <div className="mb-6">
            <h1 className="text-xl sm:text-2xl font-bold text-red-600 mb-3 flex items-center justify-center gap-2">
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              Patient Context Missing
            </h1>
            
            <p className="text-red-700 text-sm sm:text-base font-medium leading-relaxed mb-4">
                You are missing the necessary patient context to access this form.
            </p>
            
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-6">
              <p className="text-red-800 text-xs sm:text-sm">
                <strong>Next Steps:</strong> Click on the link sent to you via email or sms by the clinic to access the form.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
});

// Set display name for better debugging
PatientContextMissing.displayName = 'PatientContextMissing';

export default PatientContextMissing;